import api from '@/api';

const resource = 'atena/tela-grupo';

export default {
  getTelaGrupo(id) {
    return api.get(`${resource}/${id}`);
  },
  postTelaGrupo(data) {
    return api.post(`${resource}`, data);
  },
  putTelaGrupo(data) {
    return api.put(`${resource}/${data.identificadortelagrupo}`, data);
  },
  deleteTelaGrupo(id) {
    return api.delete(`${resource}/${id}`);
  },
  getSelectTelaGrupo() {
    return api.get(`${resource}/select`);
  },
};